import { Button } from 'antd';
import React from 'react';
import NewsPublish from '../../../components/publish-manage/NewsPublish';
import usePublish from '../../../components/publish-manage/usePublish';

export default function Sunset() {
    // 1 unpublished
    // 2 published
    // 3 sunset
    const { dataSource, handleDelete } = usePublish(3);
    return (
        <div>
            <NewsPublish dataSource={dataSource} button={id => <Button danger onClick={() => handleDelete(id)}>删除</Button>}></NewsPublish>
        </div>
    )
}
